import React, { useState } from 'react';

const CopyLink = ({ link }) => {
  // State
  const [copied, setCopied] = useState(false);

  // Methods
  const copyToClipboard = (link) => {
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      className='d-flex align-items-center justify-content-between rounded bg-secondary bg-opacity-25 p-2'
      style={{
        fontSize: '1rem',
        verticalAlign: 'middle',
      }}>
      <code className='text-dark ms-2 me-2'>{link}</code>
      <span onClick={() => copyToClipboard(link)}>
        <span
          style={{
            padding: '10px 10px',
            cursor: 'pointer',
          }}
          className='badge bg-dark bg-pill'>
          {copied ? 'Copied' : 'Copy link'}
        </span>
      </span>
    </div>
  );
};

export default CopyLink;
